module.exports = __webpack_public_path__ + "img/fae1dbb9ce224d0696e439d9e8a23426.897928b9.jpg";